import type { FC } from 'react'

import { AssetFallbackIcon } from '@skytech/ui'
import { ImageWithIconFallback } from '@skytech/ui/Image'

import { Translation } from '@/app/translations/Translation'
import { FormattedNumberWithCurrency } from '@/components/FormattedNumberWithCurrency'
import RouterLink from '@/components/RouterLink'
import { useIsAdmin } from '@/hooks/access'
import { APP_ROUTES } from '@/util/app-routes'

import type { PolicyOrderExtended } from '../types'

import './EcomPolicyOrderProducts.styles.scss'

const EcomPolicyOrderProducts: FC<{ order: PolicyOrderExtended }> = ({ order }) => {
  const isAdmin = useIsAdmin()
  return (
    <section className="ecom-policy-order-products">
      <h3>
        <Translation id="Products" />
      </h3>
      <ul>
        {order.products.map(product => (
          <li key={product.id}>
            <div className="image">
              <ImageWithIconFallback
                src={product.imgUrl}
                alt="product"
                fallbackIcon={<AssetFallbackIcon assetType={product.assetType || 'OTHER'} />}
              />
            </div>

            <div className="text">
              <div className="text__name">
                {product.quantity > 1 && `${product.quantity}x `}
                {product.productName}
              </div>

              <div className="text__cost">
                <FormattedNumberWithCurrency amount={product.cost} currency={order.currency} />
              </div>

              {isAdmin && (
                <div className="asset-links">
                  {product.assetIds?.map((assetId, index) => (
                    <RouterLink
                      key={assetId}
                      to={APP_ROUTES.HARDWARE_ASSET.replace(':id', String(assetId))}
                      hasUnderline={false}
                      className="text__order-id-link"
                    >
                      <Translation id="Go to asset" />{' '}
                      {product.assetIds && product.assetIds.length > 1 ? index + 1 : ''}
                    </RouterLink>
                  ))}
                </div>
              )}
            </div>
          </li>
        ))}
      </ul>
    </section>
  )
}

export default EcomPolicyOrderProducts
